// DS: i3.12
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const GiveBadge: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg width="0" height="0" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          d="M12.434 1a1 1 0 0 1 .857.485l2.331 3.885a1 1 0 0 1-.11 1.179l-.42.472a.945.945 0 0 1-1.334.078l-.195-.194a.83.83 0 0 1-.106-1.043l.072-.093-1.662-2.77H4.132L2.47 5.769 8 11.989a.5.5 0 0 1 .704-.04l.356.354c.397.398.416 1.036.043 1.457l-.356.4a1 1 0 0 1-1.411.082l-.083-.083L.488 6.55a1 1 0 0 1-.11-1.179l2.331-3.885A1 1 0 0 1 3.566 1zM12 7a1 1 0 0 1 1 1v1h1a1 1 0 0 1 0 2h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1V8a1 1 0 0 1 1-1"
        ></path>
      </svg>
    </IconWrap>
  );
};
GiveBadge.displayName = 'GiveBadge';

export default GiveBadge;
